import EventAlertNegative from './EventAlertNegative';

export default EventAlertNegative;
